import React, { useEffect, useRef } from 'react';
import ApexCharts, { ApexOptions } from 'apexcharts';
import { getCSS } from '../../../assets/ts/_utils';

type Props = {
  className: string,
  data: {
    series: number[],
    labels: string[]
  }
};

const DonutChart: React.FC<Props> = ({ className, data }) => {

  const chartRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {

    if (!chartRef.current) {
      return;
    }

    const height = parseInt(getCSS(chartRef.current, 'height'));
    const chartOptions = getChartOptions(height, data);

    const chart = new ApexCharts(chartRef.current, chartOptions);
    chart.render();

    return () => {
      chart.destroy();
    };

  }, [chartRef, data]);

  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>H&S Activities</span>
          <span className='text-muted fw-bold fs-7' />
        </h3>
      </div>

      <div className='card-body'>
        <div ref={chartRef} id='kt_charts_donut_widget_1' style={{ height: '364px' }} />
      </div>
    </div>
  );
};

function getChartOptions(height: number, data: any): ApexOptions {

  const defaultSeries = data.series.length > 0 ? data.series : [];
  const defaultLabels = data.labels.length > 0 ? data.labels : [];

  return {
    series: defaultSeries,
    labels: defaultLabels,
    chart: {
      height: height,
      type: 'pie',
      events: {
        dataPointSelection: function (event, chartContext, config) {
          const selectedIndex = config.dataPointIndex;
          const selectedLabel = defaultLabels[selectedIndex];
          window.location.href = `/inspection-listing?inspection_status=${selectedLabel.toLowerCase()}`;
        }
      },
    },
    dataLabels: {
      enabled: true,
    },
    noData: {
      text: 'No data available.',
      align: 'center',
      verticalAlign: 'middle',
      offsetX: 0,
      offsetY: 0,
      style: {
        fontSize: '14px',
      }
    }
  };
}

export { DonutChart };